import React, { useState } from 'react';

const ModalComponent = ({ onClose, onSubmit }) => {
  const [dpi, setDpi] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmit = () => {
    // You can perform any validation here before calling onSubmit
    if (dpi && name && description) {
      onSubmit({ dpi, name, description });
    } else {
      alert('Please fill in all fields.');
    }
  };

  return (
    <div className="modal">
      <style>
        {`
          .modal {
            position: fixed;
            top: 0;
            left: 0;
            width: 50%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.1);
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .modal-content {
            background-color: white;
            width: 50%; /* Set modal width to 50% */
            padding: 20px;
            border-radius: 5px;
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
          }

          h2 {
            margin-top: 0;
          }

          label {
            display: block;
            margin-top: 10px;
            font-weight: bold;
          }

          input,
          select {
            width: 100%;
            padding: 8px;
            margin-top: 5px;
            border: 1px solid #ccc;
            border-radius: 4px;
          }

          button {
            margin-top: 10px;
            padding: 8px 15px;
            background-color: #007bff;
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;
          }

          button:hover {
            background-color: #0056b3;
          }
        `}
      </style>
      <div className="modal-content">
        <h2>Choose Values</h2>
        <label htmlFor="dpi">DPI:</label>
        <select id="dpi" value={dpi} onChange={(e) => setDpi(e.target.value)}>
          <option value="100">100 DPI</option>
          <option value="200">200 DPI</option>
          <option value="300">300 DPI</option>
        </select>

        <label htmlFor="name">Name:</label>
        <input type="text" id="name" value={name} onChange={(e) => setName(e.target.value)} />

        <label htmlFor="description">Description:</label>
        <input type="text" id="description" value={description} onChange={(e) => setDescription(e.target.value)} />

        <button onClick={handleSubmit}>Submit</button>
        <button onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
};

export default ModalComponent;
